import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "리포지토리 구축하기",
  "description": "Turborepo를 설계하고 구축합니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "모노레포 아키텍처 설계는 신중한 과정입니다. 이 가이드를 통해 규모에 관계없이 모든 팀을 더 빠르게 만들어주는 모노레포를 설계하고 구축하는 방법을 배울 수 있습니다."
  }, {
    "heading": "",
    "content": "이 섹션의 가이드는 일반적으로 모노레포라고 불리는 멀티 패키지 워크스페이스를 구축하는 과정을 안내합니다. 이전 가이드의 지식을 바탕으로 작성되었으므로 순서대로 읽는 것이 좋지만, 원하는 순서대로 읽거나 특정 사용 사례에 해당하는 페이지로 건너뛸 수도 있습니다."
  }, {
    "heading": "",
    "content": "이 섹션을 모두 읽고 나면 Turborepo로 모노레포를 설계하고 구축하는 방법을 잘 이해하게 될 것입니다."
  }, {
    "heading": "",
    "content": "Turborepo는 단일 패키지 워크스페이스의 속도를 높이는 데에도 사용할 수\n있습니다. 자세한 내용은 단일 패키지\n워크스페이스 섹션을 참조하세요."
  }, {
    "heading": "더-많은-가이드",
    "content": "특정 도구, 사용 사례 및 기타 주제에 대한 더 많은 가이드도 제공하고 있습니다."
  }],
  "headings": [{
    "id": "처음부터-turbo까지",
    "content": "처음부터 turbo까지"
  }, {
    "id": "더-많은-가이드",
    "content": "더 많은 가이드"
  }]
};
import {Card, Cards} from '#components/card';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#처음부터-turbo까지",
  title: _jsxs(_Fragment, {
    children: ["처음부터 ", _jsx("code", {
      children: "turbo"
    }), "까지"]
  })
}, {
  depth: 2,
  url: "#더-많은-가이드",
  title: _jsx(_Fragment, {
    children: "더 많은 가이드"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "모노레포 아키텍처 설계는 신중한 과정입니다. 이 가이드를 통해 규모에 관계없이 모든 팀을 더 빠르게 만들어주는 모노레포를 설계하고 구축하는 방법을 배울 수 있습니다."
    }), "\n", _jsx(_components.p, {
      children: "이 섹션의 가이드는 일반적으로 모노레포라고 불리는 멀티 패키지 워크스페이스를 구축하는 과정을 안내합니다. 이전 가이드의 지식을 바탕으로 작성되었으므로 순서대로 읽는 것이 좋지만, 원하는 순서대로 읽거나 특정 사용 사례에 해당하는 페이지로 건너뛸 수도 있습니다."
    }), "\n", _jsx(_components.p, {
      children: "이 섹션을 모두 읽고 나면 Turborepo로 모노레포를 설계하고 구축하는 방법을 잘 이해하게 될 것입니다."
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["Turborepo는 단일 패키지 워크스페이스의 속도를 높이는 데에도 사용할 수\n있습니다. 자세한 내용은 ", _jsx(_components.a, {
          href: "/docs/guides/single-package-workspaces",
          children: "단일 패키지\n워크스페이스"
        }), " 섹션을 참조하세요."]
      })
    }), "\n", _jsxs(_components.h2, {
      id: "처음부터-turbo까지",
      children: ["처음부터 ", _jsx(_components.code, {
        children: "turbo"
      }), "까지"]
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        href: "/docs/crafting-your-repository/structuring-a-repository",
        title: "1. 리포지토리 구조화하기",
        description: "모노레포의 디렉토리 구조를 설계합니다."
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/managing-dependencies",
        title: "2. 의존성 관리하기",
        description: "코드 공유를 위한 의존성 사용"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/creating-an-internal-package",
        title: "3. 내부 패키지 생성하기",
        description: "리포지토리에 패키지 만들기"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/configuring-tasks",
        title: "4. 작업 구성하기",
        description: "작업 패턴 설계하기"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/running-tasks",
        title: "5. 작업 실행하기",
        description: "가능한 한 빠르게 작업 실행하기"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/caching",
        title: "6. 캐싱",
        description: "동일한 작업을 두 번 수행하지 않기"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/developing-applications",
        title: "7. 애플리케이션 개발하기",
        description: "여러 앱을 병렬로 실행하기"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/using-environment-variables",
        title: "8. 환경 변수 사용하기",
        description: "환경의 변수 고려하기"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/constructing-ci",
        title: "9. CI 구축하기",
        description: "애플리케이션 배포하기"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/upgrading",
        title: "10. 업그레이드하기",
        description: "Turborepo 버전 업그레이드하기"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/understanding-your-repository",
        title: "11. 리포지토리 이해하기",
        description: "Turborepo로 코드베이스 이해하기"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "더-많은-가이드",
      children: "더 많은 가이드"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/guides",
        children: "특정 도구, 사용 사례 및 기타 주제"
      }), "에 대한 더 많은 가이드도 제공하고 있습니다."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
